import React from 'react';
import Header from '../../common/Header';
import { useLocation } from 'react-router';
import Tabs from '../../common/Tabs';
import DisplayAdRequestsList from './DisplayAdRequestsList';

const DisplayAdsList = () => {
	const { pathname } = useLocation();

	return (
		<>
			<Header
				title="Display ads"
				className="pb-6"
				rightSide={
					<Tabs
						tabs={[
							{
								name: 'Requested ads',
								to: `/ad-requests`,
								active: pathname === `/ad-requests`,
							},
							{
								name: 'Display ads',
								to: `/display-ads-list`,
								active: pathname === `/display-ads-list`,
							},
						]}
					/>
				}
			/>
			<DisplayAdRequestsList />
		</>
	);
};

export default DisplayAdsList;
